import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  setPage as setPageAction,
  setRowsPerPage as setRowsPerPageAction,
  setSearch as setSearchAction,
  setTotalCount as setTotalCountAction,
} from '../../store/slices/tableSlice'

interface UseTablePaginationOptions {
  key?: string
  initialPage?: number
  initialRowsPerPage?: number
}

const useTablePagination = (options: UseTablePaginationOptions = {}) => {
  const { key = 'default', initialPage = 0, initialRowsPerPage = 10 } = options
  const dispatch = useAppDispatch()
  const tableState = useAppSelector((state) => state.tables[key])

  const page = tableState?.page ?? initialPage
  const rowsPerPage = tableState?.rowsPerPage ?? initialRowsPerPage
  const searchValue = tableState?.search ?? ''
  const totalCount = tableState?.totalCount ?? 0

  const handlePageChange = useCallback(
    (newPage: number) => {
      dispatch(setPageAction({ key, page: newPage }))
    },
    [dispatch, key]
  )

  const handleRowsPerPageChange = useCallback(
    (rowperpage: string | number) => {
      const newRowsPerPage = parseInt(String(rowperpage), 10)
      dispatch(setRowsPerPageAction({ key, rowsPerPage: newRowsPerPage }))
    },
    [dispatch, key]
  )

  const handleSearch = useCallback(
    (value: string) => {
      dispatch(setSearchAction({ key, search: value }))
    },
    [dispatch, key]
  )

  const setTotalCount = useCallback(
    (count: number) => {
      dispatch(setTotalCountAction({ key, totalCount: count }))
    },
    [dispatch, key]
  )

  return {
    page,
    rowsPerPage,
    totalCount,
    setTotalCount,
    searchValue,
    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
  }
}

export default useTablePagination
